import "./css/normalize.css"; //CSS reset
import "./css/site.css";

import React from "react";
import { Route, Routes } from "react-router-dom";

import { ROUTES, SERVICES } from "../data/content";
import ScrollToTop from "./general/ScrollToTop";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import WhatsAppButton from "./layout/WhatsAppButton";
import Home from "./home/Home";
import Services from "./services/Services";
import ServicePage from "./services/ServicePage";
import Team from "./team/Team";
import CompanyStatement from "./company/CompanyStatement";
import Testimonials from "./testimonials/Testimonials";
import Blog from "./blog/Blog";
import BlogPost from "./blog/BlogPost";
import Contact from "./contact/Contact";
import NotFound from "./general/NotFound";

const App = () => {
  return (
    <React.Fragment>
      <a
        className={"skip-link"}
        href={"#main"}
      >
        Skip to main content
      </a>
      <ScrollToTop />
      <Header />
      <main
        id={"main"}
        className={"site-main"}
      >
        <Routes>
          <Route
            path={ROUTES.HOME}
            element={<Home />}
          />
          <Route
            path={ROUTES.SERVICES}
            element={<Services />}
          />
          {SERVICES.map((service) => (
            <Route
              key={service.path}
              path={service.path}
              element={<ServicePage service={service} />}
            />
          ))}
          <Route
            path={ROUTES.TEAM}
            element={<Team />}
          />
          <Route
            path={ROUTES.COMPANY_STATEMENT}
            element={<CompanyStatement />}
          />
          <Route
            path={ROUTES.TESTIMONIALS}
            element={<Testimonials />}
          />
          <Route
            path={ROUTES.BLOG}
            element={<Blog />}
          />
          <Route
            path={`${ROUTES.POST}/:slug`}
            element={<BlogPost />}
          />
          <Route
            path={ROUTES.CONTACT}
            element={<Contact />}
          />
          <Route
            path={"*"}
            element={<NotFound />}
          />
        </Routes>
      </main>
      <Footer />
      <WhatsAppButton />
    </React.Fragment>
  );
};

export default App;
